export default function Header({ title, children }) {
  return (
    <div className="mb-2 flex items-center justify-between">
      <h3 className="text-base sm:text-lg font-semibold" style={{ color: "#0A3E91" }}>{title}</h3>
      <div className="flex items-center gap-2">{children}</div>
    </div>
  );
}